module.exports = __webpack_public_path__ + "static/REF-a554e32f8fad935399ebe108e9dfd55b.svg";